import { useCallback, useState } from 'react';
import { GetAllProjects } from '../services/api/methods.ts';
import { Project } from '../services/api/types.ts';

export const useProject = () => {
    const [projects, setProjects] = useState<Project[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadProjects = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const result = await GetAllProjects();
            setProjects(result.Projects);
        } catch (err) {
            setError('Не удалось загрузить проекты');
            console.error('Не удалось загрузить проекты', err);
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        projects,
        loading,
        error,
        loadProjects,
        setProjects,
        setError
    };
};
